<script>
    import { client, gql } from "../../GraphQL.svelte";
    import { emptyValuation } from "../../Contributor.svelte";
    import { isOwnerOfProject } from "../../Me.svelte";
    import { ENTRIES_FRAGMENT } from "../../Participaid.svelte";

    import Util from "../../lib/util.js";
    import FSM from "../../lib/fsm.js";
    import ContributorModel from "../../models/participaid/Contributor.js";
    import ProjectModel from "../../models/participaid/Project.js";

    import Overlay from "../Overlay.svelte";
    import ProfilePicture from "../ProfilePicture.svelte";
    import TimeAgo from "../TimeAgo.svelte";
    import SettingsButton from "../buttons/SettingsButton.svelte";
    import EntryTags from "../form/EntryTags.svelte";
    import LoadingModal from "../LoadingModal.svelte";
    import ContributionTableItem from "./ContributionTableItem.svelte";
    import NewEntryDialog from "../dialogs/NewEntryDialog.svelte";
    import Button from "../form/Button.svelte";
    import Notification from "../Notification.svelte";

    import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';

    export let project;
    export let myUserId;
    export let colors;
    export let isOwner;
    export let editable;
    export let contributors;
    export let sortProp = "creationTime";

    let contributionsRequest;
    let contributions = [];
    let fields = [];
    let errorMsg;

    let showNewEntryDialogForContributor = false;

    $: showDialog = showNewEntryDialogForContributor;
    $: hasFields = project && ProjectModel.hasFields(project);

    // make hashmap ordered by id
    $: contributorMap = contributors.reduce((acc, val) => {
        if (val.__typename && val.__typename == "Contributor")
            acc[val.id] = val;
        return acc;
    }, {});

    $: if (contributions.length) {
        let contributions2 = [...contributions];

        contributions2.sort((a, b) => {
            var nameA = a.creationTime.toUpperCase(); // ignore upper and lowercase
            var nameB = b.creationTime.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return 1;
            }
            if (nameA > nameB) {
                return -1;
            }

            // names must be equal
            return 0;
        });

        contributions = contributions2;
    }

    const ENTRIES_QUERY = gql`
        query($projectId: String!) {
            administrativePeriods(projectId: $projectId) {
                endDate, id, isSettled, startDate, contributions {
                    ${ENTRIES_FRAGMENT}
                }
            }
        }
    `;

    const ENTRIES_CONTRIBUTOR_QUERY = gql`
        query {
            me {
                contributingProjects {
                    id,
                    contributions {
                        ${ENTRIES_FRAGMENT}
                    }
                }
            }
        }
    `;

    function closeDialogs() {
        showNewEntryDialogForContributor = false;
    }

    function handleDeletedContribution(evt) {
        // TODO
    }

    function handleNewEntry() {
        showNewEntryDialogForContributor = false;
        reload();
    }

    function loadRequestOwner() {
        // first request high-level summary
        return client.query({
            query: ENTRIES_QUERY,
            fetchPolicy: "network-only",
            variables: {
                projectId: project.id
            }
        })

        //
        .then(res => {
            console.log(`successfully retrieved contributions`);
            console.log(res);

            //contributions = res.data.contributions;
            contributions = res.data.administrativePeriods.reduce((acc, val) => {
                console.log(val);
                return [...acc, ...(val.contributions || [])];
            }, []);
        })
    }

    function loadRequestContributor() {
        // first request high-level summary
        return client.query({
            query: ENTRIES_CONTRIBUTOR_QUERY,
            fetchPolicy: "network-only"
        })

        //
        .then(res => {
            console.log(`successfully retrieved contributor contributions`);
            console.log(res);

            res.data.me.contributingProjects.forEach(proj => {
                if (proj.id == project.id) {
                    contributions = proj.contributions;
                }
            });
        })
    }

    function loadRequest() {
        if (isOwner) {
            return loadRequestOwner()
        }
        else {
            return loadRequestContributor()
        }
    }

    function reload() {
        contributionsRequest = loadRequest().catch(err => {
            console.err(err);
            errorMsg = "There was an error retrieving contributions...";
        });
    }

    reload();
</script>

{#await contributionsRequest}
    <LoadingModal global={false} background="none" loaderBackground="none"/>
{:then}

{:catch err}
    <Notification type="error" message="There was an error loading the contributions" />
{/await}

{#if contributions.length}
    <div class="new-entry-create-embed">
        <Button disabled={!hasFields}
                style="margin-bottom: 25px"
                on:click={() => showNewEntryDialogForContributor = true}>
            Create new...
        </Button>
    </div>

    <div>
        {#each contributions as contribution}
            {#if contribution.contributor}
                <ContributionTableItem
                        {project}
                        model={contribution}
                        {isOwner}
                        {myUserId}
                        {editable}
                        contributor={contributorMap[contribution.contributor.id]}
                        on:approved
                        on:rejected
                        on:deleted/>
            {:else}
                <div class="contribution-error" style="display: none">
                    Could not find contributor for entry
                </div>
            {/if}
        {/each}
    </div>
{:else}
    No entries yet! <Button disabled={!hasFields} on:click={() => showNewEntryDialogForContributor = true}>Create new...</Button>

    {#if !hasFields}
        <small style="display: block;">(Cannot create entries without defined entry fields.)</small>
    {/if}
{/if}

<Notification type="error" message={errorMsg} />

<Overlay show={showDialog} closable={true} on:close={closeDialogs} background="darken" loaderBackground="#fff">
    {#if showNewEntryDialogForContributor}
        <NewEntryDialog
                {project}
                {isOwner}
                on:new={handleNewEntry}
        />
    {/if}
</Overlay>